// extracted by mini-css-extract-plugin
export default {"posCard":"OsQtQNvMH1KQiog7NDRW","posCardMobile":"bOz7tA10in2ATtwYMDWE","posCardLaptop":"JnNUAIraYFsHDeTmANrB","fullWidthPosCard":"vEGnHeR4apio7YMmUBBb"};